import React from 'react';
import FormErrorMessage from "../../../common/form/form_error_message";
import FormInput from "../../../common/form/form_input";
import {Link} from "react-router-dom";
import InfoCardAuthenticator from "../../../main/component/info-cards/info-card--authenticator";
import {_t} from "../../../../js/app/common/utils/locale";

export default function render(props) {
    return (
        <section className="section section-cluster-form section-2fa">
            <section className="cluster-form-card login-card login-card__authenticator">

                <div className="btn-bar--back">
                    <a className="link link--primary link--icon-left" href="/logout"><i className="fal ico fa-long-arrow-left"></i> {_t('Cancel and go back')}</a>
                </div>

                <InfoCardAuthenticator />

                <div className="cluster-form-card__body login-card__form">
                    <header className="cluster-form-card__header">
                        <h2 className="title title--h2">{_t('Enter code from Google Authenticator')}</h2>
                    </header>

                    <FormErrorMessage message={this.state.error_message} />

                    <FormInput
                        autoFocus={true}
                        name={'code'}
                        label={'Google Authenticator code'}
                        onChange={this.onChangeInput.bind(this)}
                        errors={this.state.errors.code}
                        labelClass="code-2fa"
                        onKeyPress={this.onKeyPress.bind(this)}
                    />

                    <div className="btn-bar">
                        <button className="btn btn--alt"  onClick={this.onSubmit.bind(this)}>{_t('Login')}</button>
                    </div>
                </div>

            </section>
        </section>
    );
};